// Diagnostic records deliberately exclude URLs, credentials, prompts and bodies.
export async function requestJSON(url, options, {requestId,diagnostic=false,responseShape='object',fetchImpl=fetch,log=console.warn,now=Date.now}={}) {
 const startedAt=now();let response;
 const id=typeof requestId==='string'&&/^[a-zA-Z0-9-]{16,80}$/.test(requestId)?requestId:null;
 function failure(message,kind){
  const elapsedMs=Math.max(0,now()-startedAt),status=response?.status||0;
  const record={event:'editor_ai_response',requestId:id,status,elapsedMs,kind};
  if(diagnostic)log(JSON.stringify(record));
  const error=new Error(message+(diagnostic&&id?`（編號 ${id}）`:''));
  if(diagnostic)error.diagnostic=record;
  return error;
 }
 try{response=await fetchImpl(url,options);}catch{
  throw failure('連線中斷，草稿與上一份建議仍保留，請稍後重試。','network');
 }
 let json;
 try{json=await response.json();}catch{
  throw failure(`服務回應異常（HTTP ${response.status}），草稿與上一份建議仍保留，請稍後重試。`,'invalid_json');
 }
 // Successful collection endpoints return arrays; HTTP errors still use an object.
 const validShape=response.ok&&responseShape==='array'?Array.isArray(json):json&&typeof json==='object'&&!Array.isArray(json);
 if(!validShape)throw failure(`服務回應異常（HTTP ${response.status}），請稍後重試。`,'invalid_shape');
 if(!response.ok){
  const error=failure(json.error||'操作未完成，請重試。','http');
  error.current=json.current;error.cancelled=json.cancelled;throw error;
 }
 return json;
}
